<template>
  <div class="client-page">
    <transition name="fade">
      <div v-if="loading" class="page-loader d-flex flex-column justify-content-center align-items-center">
        <div class="loader-card text-center">
          <div class="loader-spinner mb-3"></div>
          <h5 class="loader-title mb-2">Nous calculons vos offres de mutuelles…</h5>
          <p class="loader-sub mb-3">Cela ne prendra que quelques instants.</p>

          <div class="loader-progress" role="progressbar" :aria-valuenow="progress" aria-valuemin="0" aria-valuemax="100">
            <div class="loader-progress-bar" :style="{ width: progress + '%' }"></div>
          </div>
          <div class="loader-progress-value">{{ Math.round(progress) }}&nbsp;%</div>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
export default {
  name: 'Client',
  props: {
    mutuelles: { type: Array, default: () => [] },
    // Passe à true dès que l'API a répondu côté parent.
    // Le loader accélère alors jusqu'à 100 % puis émet @finished.
    isDone: { type: Boolean, default: false },
  },
  data() {
    return {
      loading: true,
      progress: 0,
      progressInterval: null,
      finishingInterval: null,
      // Cible : 80 secondes pour arriver à ~95 %, soit le temps maximum
      // observé de la réponse API. La courbe est linéaire pour rester
      // prévisible (pas de palier qui donne l'impression d'être bloqué).
      maxBeforeDone: 95,
      durationSec: 32,
    }
  },
  mounted() {
    const tickMs = 200;
    const totalTicks = (this.durationSec * 1000) / tickMs;
    const step = this.maxBeforeDone / totalTicks;
    this.progressInterval = setInterval(() => {
      if (this.progress < this.maxBeforeDone) {
        this.progress = Math.min(this.maxBeforeDone, this.progress + step);
      }
    }, tickMs);
  },
  watch: {
    isDone(val) {
      if (val) this.finishFast();
    }
  },
  methods: {
    // Accélération finale : 0→100 % en ~600 ms après réponse API
    finishFast() {
      if (this.progressInterval) {
        clearInterval(this.progressInterval);
        this.progressInterval = null;
      }
      if (this.finishingInterval) return;
      this.finishingInterval = setInterval(() => {
        const remaining = 100 - this.progress;
        // Plus on est proche de 100, plus on accélère pour donner l'impression
        // d'un "snap" final propre
        const step = Math.max(2, remaining * 0.25);
        this.progress = Math.min(100, this.progress + step);
        if (this.progress >= 100) {
          clearInterval(this.finishingInterval);
          this.finishingInterval = null;
          // Laisse 200 ms pour que la transition CSS de la barre se voie
          setTimeout(() => this.$emit('finished'), 200);
        }
      }, 30);
    }
  },
  beforeDestroy() {
    if (this.progressInterval) clearInterval(this.progressInterval);
    if (this.finishingInterval) clearInterval(this.finishingInterval);
  }
}
</script>

<style scoped>
.page-loader {
  position: fixed;
  top: 0; left: 0; right: 0; bottom: 0;
  background-color: rgba(255, 255, 255, 0.94);
  z-index: 2000;
  backdrop-filter: blur(3px);
}

.loader-card {
  background: #fff;
  border-radius: 20px;
  padding: 40px 48px;
  box-shadow: 0 12px 40px rgba(20, 40, 80, 0.14);
  max-width: 480px;
  width: 90%;
}

.loader-spinner {
  width: 56px; height: 56px;
  margin: 0 auto;
  border-radius: 50%;
  border: 5px solid #E8F0FE;
  border-top-color: #1E5BC6;
  animation: loader-spin 0.9s linear infinite;
}
@keyframes loader-spin { to { transform: rotate(360deg); } }

.loader-title {
  font-size: 18px;
  font-weight: 800;
  color: #142850;
  margin: 0;
}
.loader-sub {
  font-size: 14px;
  color: #4A5A78;
  margin: 0;
}

.loader-progress {
  position: relative;
  height: 10px;
  background: #EFF2F8;
  border-radius: 999px;
  overflow: hidden;
  margin: 12px 0 6px;
}
.loader-progress-bar {
  height: 100%;
  background: linear-gradient(90deg, #1E5BC6 0%, #E63946 100%);
  border-radius: 999px;
  transition: width 0.25s ease;
}
.loader-progress-value {
  font-size: 14px;
  font-weight: 800;
  color: #1E5BC6;
  margin-top: 4px;
}

.fade-enter-active, .fade-leave-active { transition: opacity 0.4s; }
.fade-enter, .fade-leave-to { opacity: 0; }
</style>
